// دیکود کردن Payload یک JWT، بدون هیچ کتابخانه‌ی خارجی
export function parseJwt(token) {
    if (!token) return null;
    try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split("")
                .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
                .join("")
        );
        return JSON.parse(jsonPayload);
    } catch {
        return null;
    }
}

// کلید رسمی ClaimTypes.Role که .NET موقع صدور توکن (نه موقع Validate) از همین فرم استفاده می‌کند
const ROLE_CLAIM_KEY = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";

export function getCurrentRoles() {
    const token = localStorage.getItem("token");
    const payload = parseJwt(token);
    if (!payload) return [];

    // هم فرم کوتاه "role" و هم فرم بلند رسمی را چک می‌کنیم، هرکدام موجود بود همان استفاده می‌شود
    const role = payload.role ?? payload[ROLE_CLAIM_KEY] ?? [];
    return Array.isArray(role) ? role : [role];
}

export function isSuperAdmin() {
    return getCurrentRoles().includes("SuperAdmin");
}

export function getCurrentPermissions() {
    const token = localStorage.getItem("token");
    const payload = parseJwt(token);
    if (!payload) return [];
    const perms = payload.Permission ?? [];
    return Array.isArray(perms) ? perms : [perms];
}

export function hasPermission(permissionKey) {
    return getCurrentPermissions().includes(permissionKey);
}